import Language, { ILanguage } from "../../model/language/Language";
import { IHttpService } from "../HttpService";

export interface ILanguageService {
  getLanguages(): Promise<ILanguage[]>;
  getLanguage(languageCode: string): Promise<ILanguage>;
  changeLanguage(languageCode: string): Promise<any>;
}

const LanguageService = ({ httpService }): ILanguageService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _languagesPath: string = "/languages";
  const LanguageListMapper = (json = []) => {
    return json.map((item: any) => {
      var language = {
        code: item.code,
        name: item.value,
        id: item.id
      } as ILanguage;
      return Language(language);
    });
  };

  return {
    async getLanguages() {
      const path = _http.buildPath(_baseUrl, _languagesPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);

      return LanguageListMapper(responseJSON);
    },

    async getLanguage(languageCode: string) {
      const path = _http.buildPath(_baseUrl, _languagesPath, languageCode);

      const response = await _http.get(path);

      const responseJSON = await _http.toJSON(response);

      return responseJSON;
    },
    async changeLanguage(languageCode: string) {
      const path = _http.buildPath(_baseUrl, _languagesPath);
      const response = await _http.put(path, {
        params: {
          code: languageCode
        },
        form: true
      });
      return _http.toText(response);
    }
  };
};

export default LanguageService;
